import { render, staticRenderFns } from "./advance.vue?vue&type=template&id=08984ba1&scoped=true"
import script from "./advance.vue?vue&type=script&lang=js"
export * from "./advance.vue?vue&type=script&lang=js"
import style0 from "./advance.vue?vue&type=style&index=0&id=08984ba1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08984ba1",
  null
  
)

export default component.exports